import { render, staticRenderFns } from "./UserConfigParamsEdit.vue?vue&type=template&id=b6c1199a"
import script from "./UserConfigParamsEdit.vue?vue&type=script&lang=js"
export * from "./UserConfigParamsEdit.vue?vue&type=script&lang=js"
import style0 from "./UserConfigParamsEdit.vue?vue&type=style&index=0&id=b6c1199a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports